export default "__VITE_ASSET__CUwuV5l2__"